// extracted by mini-css-extract-plugin
export default {"menuButton":"jLiFgh46itTTwBCOYQT7","iconGlobe":"VktVWAv5GzTvbqRVlgO4","menuItem":"bMcplD1n3YwqO8GPdJPU","menuItemActive":"_QPaAogEH2j250HIhsxr"};